import { httpClient } from '@alfa-bank/site-http-client';

import type { ISuggestion, ISuggestionRequest, TNamePart } from './models';
import { FIRST_NAME, LAST_NAME, PATRONYMIC } from './models';
import { URL, HEADERS } from './config';

export class DaDataService {
    fetchSuggestions = async ({
        controller,
        gender,
        namePart,
        value,
    }: ISuggestionRequest): Promise<ISuggestion[]> => {
        try {
            const response = await httpClient.post<{ suggestions: ISuggestion[] }>(
                URL as string,
                {
                    parts: [namePart],
                    gender,
                    query: value,
                    signal: controller.signal,
                },
                {
                    headers: HEADERS,
                }
            );

            return response?.data?.suggestions || [];
        } catch (e: any) {
            return [];
        }
    };

    fetchNamePart =
        (namePart: TNamePart) =>
        (queryParams: ISuggestionRequest): Promise<ISuggestion[]> =>
            this.fetchSuggestions({ ...queryParams, namePart });

    fetchFirstName = this.fetchNamePart(FIRST_NAME);

    fetchLastName = this.fetchNamePart(LAST_NAME);

    fetchPatronymic = this.fetchNamePart(PATRONYMIC);
}
